import React, { useEffect, useState } from 'react';
import { LinkinBio, LinkinBioHeaderProps, LinkinBioArticle, LinkinBioNotFound } from 'socialflow-linkinbio';
import { getPosts, getAccountMetadata } from '../../api';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

const PlaceholderText: React.FC<{ text: string }> = ({ text }) => {
  const style: React.CSSProperties = {
    height: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  return (
    <Container style={style}>
      <Typography align="center" style={{ color: '#666' }} variant="h4">
        {text}
      </Typography>
    </Container>
  );
};

export const LinkinBioModule: React.FC<{ pageHandle?: string }> = ({ pageHandle }) => {
  const [metaData, setMetaData] = useState<LinkinBioHeaderProps | null>(null);
  const [articles, setArticles] = useState<LinkinBioArticle[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [invalidAccount, setInvalidAccount] = useState<boolean>(false);

  useEffect(() => {
    if (!pageHandle) {
      setLoading(false);
      return;
    }
    (async () => {
      const [accountData, postData] = await Promise.all([getAccountMetadata(pageHandle), getPosts(pageHandle)]);
      if (accountData) setMetaData(accountData);
      else setInvalidAccount(true);
      if (postData?.length) {
        setArticles(postData);
        if (postData?.length < 10 && accountData) setMetaData({ ...accountData, hasMoreArticles: false });
      } else if (accountData) setMetaData({ ...accountData, hasMoreArticles: false });
      setLoading(false);
    })();
  }, []);

  const loadingMetaDataState: LinkinBioHeaderProps = { avatar: '', link: '' };

  const getMorePosts = (article: LinkinBioArticle) => {
    if (!pageHandle) return;
    getPosts(pageHandle, article.publishTimeEpoch).then((posts) => {
      if (posts) {
        setArticles([...articles, ...posts]);
        if (posts.length < 4 && metaData) {
          setMetaData({ ...metaData, hasMoreArticles: false });
        }
      }
    });
  };

  if (!pageHandle) return <PlaceholderText text="Uh oh, that account does not appear to exist." />;
  if (invalidAccount)
    return (
      <div className="App" data-testid="lib-app-loaded">
        <LinkinBioNotFound errorMsg="Whoops, that account doesn't exist." handlerName={pageHandle} />
      </div>
    );
  return (
    <div className="App" data-testid="lib-app-loaded">
      <LinkinBio
        metaData={metaData || loadingMetaDataState}
        articles={articles}
        fetchArticles={getMorePosts}
        loading={loading}
      ></LinkinBio>
    </div>
  );
};
